import {ApolloClient, InMemoryCache, createHttpLink, from} from '@apollo/client'
import {setContext} from '@apollo/client/link/context'
import config from './config'
import {onError} from '@apollo/client/link/error'
import {ErrorLogger} from './telemetry/ErrorLogger'

const httpLink = createHttpLink({
  uri: config.GRAPHQL_URL,
})

// Create an error handling link
const errorLink = onError(({graphQLErrors, networkError, operation}) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((error) => {
      ErrorLogger.logGraphQLError({
        ...error,
        operation: {
          operationName: operation.operationName,
          variables: operation.variables,
        },
      })
    })
  }

  if (networkError) {
    ErrorLogger.logNetworkError(networkError, 'apollo')
  }
})

const authLink = setContext((_, {headers}) => {
  const token = sessionStorage.getItem('accessToken')
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }
})

const apolloClient = new ApolloClient({
  link: from([errorLink, authLink.concat(httpLink)]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
})

export default apolloClient
